import React, {useMemo, useState, useEffect} from "react";
import {Link} from "react-router-dom";
import objectPath from "object-path";
import {Brand} from "../brand/Brand";
import { useSelector, shallowEqual } from "react-redux";
import {AsideMenu} from "./aside-menu/AsideMenu";
import {useHtmlClassService} from "../../_core/MetronicLayout";

export function Aside(props) {
  const uiService = useHtmlClassService();

  const { user } = useSelector((state) => state.auth, shallowEqual);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 80);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const layoutProps = useMemo(() => {
    return {
      disableScroll:
          objectPath.get(uiService.config, "aside.menu.dropdown") === "true" ||
          false,
      asideClassesFromConfig: uiService.getClasses("aside", true),
      disableAsideSelfDisplay:
          objectPath.get(uiService.config, "aside.self.display") === false,
      headerLogo: uiService.getLogo()
    };
  }, [uiService]);
  return (
      <>
        <style>{`
          #kt_aside.mykorek-scroll.aside-compact {
            top: 50px !important;
            transition: top 0.15s ease;
          }
          #kt_aside #kt_brand {
            height: auto !important;
            min-height: 0 !important;
            padding-top: 12px !important;
            padding-bottom: 12px !important;
          }
          #kt_aside.aside-compact #kt_brand {
            padding-top: 8px !important;
            padding-bottom: 8px !important;
          }
          #kt_aside.aside-compact #kt_brand .brand-prof-pic {
            width: 32px !important;
            height: 32px !important;
            transition: all 0.2s ease;
          }
          #kt_aside.aside-compact #kt_brand .font-size-base,
          #kt_aside.aside-compact #kt_brand .font-size-xs {
            font-size: 0.8rem !important;
            line-height: 1.1 !important;
          }
          #kt_aside.aside-compact .menu-nav .menu-item > .menu-link {
            padding-top: 6px !important;
            padding-bottom: 6px !important;
          }
          #kt_aside.aside-compact .menu-nav .menu-item .menu-text {
            font-size: 0.85rem !important;
          }
          #kt_aside.aside-compact .menu-nav .menu-item .menu-icon svg,
          #kt_aside.aside-compact .menu-nav .menu-item .menu-icon i {
            width: 18px !important;
            height: 18px !important;
            font-size: 1rem !important;
          }
          #kt_aside.aside-compact .blue-program-btn .menu-link img {
            height: 24px !important;
          }
          #kt_aside.aside-compact .blue-program-btn .menu-desc {
            font-size: 0.75rem !important;
          }
          #kt_aside #kt_brand {
            transition: padding 0.15s ease;
          }
          #kt_aside #kt_brand .brand-prof-pic {
            transition: width 0.15s ease, height 0.15s ease;
          }
          #kt_aside #kt_brand .font-size-base,
          #kt_aside #kt_brand .font-size-xs,
          #kt_aside .menu-nav .menu-item .menu-text,
          #kt_aside .blue-program-btn .menu-desc {
            transition: font-size 0.15s ease;
          }
          #kt_aside .menu-nav .menu-item > .menu-link {
            transition: padding 0.15s ease;
          }
          #kt_aside .blue-program-btn .menu-link img {
            transition: height 0.15s ease;
          }
        `}</style>
        {/* begin::Aside */}
        <div id="kt_aside"
             className={`aside aside-left  ${layoutProps.asideClassesFromConfig} ${props.navbar && " mykorek-scroll "} ${scrolled ? "aside-compact" : ""} d-flex flex-column flex-row-auto`}>
          <Brand user={user}/>

          {/* begin::Aside Menu */}
          <div id="kt_aside_menu_wrapper" className="aside-menu-wrapper flex-column-fluid">
            {layoutProps.disableAsideSelfDisplay && (
              <>
                {/* begin::Header Logo */}
                <div className="header-logo">
                  <Link to="">
                    <img alt="logo" src={layoutProps.headerLogo}/>
                  </Link>
                  
                </div>
                {/* end::Header Logo */}
              </>
            )}
            <AsideMenu disableScroll={layoutProps.disableScroll}/>
          </div>
          {/* end::Aside Menu */}
        </div>
        {/* end::Aside */}
      </>
  );
}
